import styled from 'styled-components';
import { container, fontSize, screen } from 'theme';

const Root = styled.div`
  max-width: ${container('lg')};
  margin: 0 auto 3rem auto;

  h2 {
    margin-top: 0;
    font-size: ${fontSize('xl2')};
    text-wrap: balance;
  }

  p {
    font-size: ${fontSize('lg')};
    line-height: 1.75;
    margin: 0 auto;
  }

  p:first-child {
    font-size: ${fontSize('lg')};
    font-weight: 800;
    margin-bottom: 0;
  }

  p:last-child {
    margin: 0 auto;
  }

  @media (min-width: ${screen('lg')}) {
    text-align: center;

    h2 {
      font-size: ${fontSize('xl4')};
    }
  }
`;

export const TalentIntroStyles = {
  Root
};
